import script from "./ProductTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTable.vue?vue&type=script&lang=ts&setup=true"

import "./ProductTable.vue?vue&type=style&index=0&id=35afcded&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35afcded"]])

export default __exports__